import React from 'react';

import {
  Typography,
  Row,
  Col,
  Form,
  Radio,
  Checkbox,
  Tooltip,
  Alert,
} from 'antd';

import { TypePicker } from 'common/components';

import { useGetMemberInfo } from 'hooks';

import { FOLDER_DOWNLOAD_TYPE, FOLDER_DELIVERY_METHOD } from 'static/Constants';

import { useIntl } from 'react-intl';
import Messages from 'i18n/messages/folder';

const { Paragraph } = Typography;

const formFormatLayout = { labelCol: { span: 12 } };
const formCheckboxLayout = { labelCol: { span: 22 }, wrapperCol: { span: 2 } };

const formItemStyle = { style: { marginBottom: 8 } };
const typePickerStyle = { padding: 4, height: 38, width: 32 };

const requiredRule = { required: true, message: 'This field is required' };

const DownloadFolderBasicSetting = (props) => {
  const form = Form.useFormInstance();
  const deliveryMethod = Form.useWatch('deliveryMethod', form);
  const intl = useIntl();

  const { memberInfo } = useGetMemberInfo();

  return (
    <>
      <Paragraph style={{ textAlign: 'center' }}>
        Please select the appropriate options to configure your download...
      </Paragraph>
      <Row gutter={8}>
        <Col span={14}>
          <Form.Item
            {...formFormatLayout}
            {...formItemStyle}
            name='downloadType'
            label={intl.formatMessage({
              id: `Taco.folder.download.configuration.downloadType`,
            })}
            rules={[requiredRule]}
          >
            <Radio.Group>
              {FOLDER_DOWNLOAD_TYPE?.map((option, index) => {
                return (
                  <Tooltip
                    title={`${option.toUpperCase()} File Extension Download`}
                    key={`type-${index}`}
                  >
                    <Radio.Button
                      value={option.toLowerCase()}
                      style={typePickerStyle}
                    >
                      <TypePicker group='file-type' type={option} />
                    </Radio.Button>
                  </Tooltip>
                );
              })}
            </Radio.Group>
          </Form.Item>

          <Form.Item
            {...formFormatLayout}
            {...formItemStyle}
            name='deliveryMethod'
            label={intl.formatMessage({
              id: `Taco.folder.download.configuration.deliveryMethod`,
            })}
            rules={[requiredRule]}
          >
            <Radio.Group>
              {FOLDER_DELIVERY_METHOD?.map((option, index) => {
                if (option === 'ftp' && !memberInfo?.ftpEnabled) return null;

                return (
                  <Tooltip
                    title={intl.formatMessage({
                      id: `Taco.folder.download.configuration.deliveryMethod.${option}`,
                    })}
                    key={`method-${index}`}
                  >
                    <Radio.Button
                      value={option.toLowerCase()}
                      style={typePickerStyle}
                    >
                      <TypePicker group='download-method' type={option} />
                    </Radio.Button>
                  </Tooltip>
                );
              })}
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            {...formCheckboxLayout}
            {...formItemStyle}
            name='includeSubfolders'
            label={intl.formatMessage(Messages.downloadIncludeAll)}
            valuePropName='checked'
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            {...formCheckboxLayout}
            {...formItemStyle}
            name='keepFolderStructure'
            label={intl.formatMessage(Messages.downloadKeepStructure)}
            valuePropName='checked'
          >
            <Checkbox />
          </Form.Item>

          <Form.Item
            {...formCheckboxLayout}
            {...formItemStyle}
            name='isOneDirectory'
            label={intl.formatMessage(Messages.isOneDirectory)}
            valuePropName='checked'
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
      {deliveryMethod === 'direct' ? (
        <Alert
          type='warning'
          message={intl.formatMessage(Messages.disabledScheduleDownloadMessage)}
          showIcon
        />
      ) : null}
    </>
  );
};

export default DownloadFolderBasicSetting;
